@defer (on hover) {
  <div
    nz-tooltip
    [nzTooltipTitle]="tooltip"
    class="overtime_kpi_parent_container"
  >
    <ng-container *ngTemplateOutlet="overtimeValue"></ng-container>
  </div>
} @placeholder {
  <div class="overtime_kpi_parent_container">
    <ng-container *ngTemplateOutlet="overtimeValue"></ng-container>
  </div>
}

<ng-template #overtimeValue>
  <span class="overtime_kpi_title text-truncate">
    {{ 'shift_timeline.kpi_setting.overtime' | translate }}
  </span>
  <div class="overtime-value">
    @if (!isLoadingUsersOvertimes) {
      @if (overtimeInMinutes) {
        <div class="d-flex align-items-center">
          @if (overtimeInMinutes | overtimeIcon; as icon) {
            <fa-icon
              [icon]="icon.name"
              [ngClass]="['ant-design-' + icon.color + '-5']"
            ></fa-icon>
          }
          <span class="overtime_kpi_value">
            {{ overtimeInMinutes | minutesToHHmmDuration }}
          </span>
        </div>
      } @else {
        <span class="overtime_kpi_value" nzType="secondary">
          {{ 'general.n/a' | translate }}
        </span>
      }
    } @else {
      <div class="skeleton-loading">
        <nz-skeleton
          [nzActive]="true"
          [nzParagraph]="{ rows: 1 }"
          [nzTitle]="false"
        ></nz-skeleton>
      </div>
    }
  </div>
</ng-template>

<ng-template #tooltip>
  <span class="fw-normal">
    {{ 'shift_timeline.kpi_setting.overtime' | translate }}
  </span>
  <span class="d-block">
    {{ 'overtime_value.tooltip' | translate }}
  </span>
</ng-template>
